import {
  Box,
  Flex,
  Select,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  Stack,
  Spinner,
  Badge,
  useColorModeValue,
  Grid,
  GridItem,
  Icon,
  Avatar,
} from "@chakra-ui/react";
import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import User_Table_View from "./User_Table_View";
import User_Reg_Form from "./User_Reg_Form";

const Registration = () => {
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef();

  return (
    <Box maxWidth="100%">
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>Event Details</h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            <div className="export-dropdown">
              <User_Reg_Form /> {/* Embeds the Bus_Create_form component */}
            </div>
          </div>
        </div>

        <Box className="breadcrumb">
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Event </span> /
          <Link
            to="/class/classlist"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Event Details</span>
          </Link>
        </Box>
      </div>

      <Box flex="2" mb={9}>
        {/* Display the User_Table_View directly */}
        <User_Table_View />
      </Box>
    </Box>
  );
};

export default Registration;
